/* eslint-disable spaced-comment */
import { combineReducers } from 'redux';
import { registry } from '@carvana/purchase-store';
import contracts from '../components/order-placed/components/contracts/ducks/reducer';
import customerRequest from '../components/customer-request/ducks/reducer';
import fundsVerification from '../components/order-placed/components/funds-verification/ducks/reducer';
import insurance from '../components/insurance-landing/ducks/reducer';
import notifications from '../components/order-placed/components/notifications/ducks/reducer';
import rescheduleModal from '../components/order-placed/components/modals/ducks/reducer';
import notarize from '../components/order-placed/components/notarize/ducks/reducer';
import root from './reducer';

const initState = {
  isLoading: false,
  hasLoaded: false
};

const reducer = combineReducers({
  contracts,
  customerRequest,
  fundsVerification,
  insurance,
  rescheduleModal,
  notifications,
  root,
  notarize
});

export const init = reg =>
  (reg || registry).register('orderPlaced', reducer, initState);
